// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/grid-body","root":"grid-body-m__root__25Suj"};